// Where a message actually came from.
//
// This lives in one place because the Queue and Responses views each used to
// carry their own `isWhatsApp ? 'WhatsApp' : 'Email'` ternary — so the day
// Facebook comments started arriving, both views confidently badged them
// "Email" and a consultant went hunting for a mailbox thread that did not
// exist. Any new channel needs one entry here, not a hunt through JSX.

const CHANNELS = {
  email: { label: 'Email', classes: 'bg-blue-100 text-blue-800' },
  whatsapp: { label: 'WhatsApp', classes: 'bg-green-100 text-green-800' },
  facebook: { label: 'Facebook', classes: 'bg-indigo-100 text-indigo-800' },
  messenger: { label: 'Messenger', classes: 'bg-purple-100 text-purple-800' },
};

// Synthetic ticket-id prefixes, which are how legacy rows (written before the
// tickets.channel column existed) still reveal their origin.
const ID_PREFIXES = [
  ['wa:', 'whatsapp'],
  ['fb:comment:', 'facebook'],
  ['fb:psid:', 'messenger'],
  ['fb:', 'facebook'],
];

export function resolveChannel(ticket) {
  const raw = (ticket?.channel || '').toLowerCase();
  if (CHANNELS[raw] && raw !== 'email') return raw;
  const id = ticket?.freshdesk_ticket_id || '';
  const hit = ID_PREFIXES.find(([prefix]) => id.startsWith(prefix));
  if (hit) return hit[1];
  return CHANNELS[raw] ? raw : 'email';
}

export function channelMeta(channel) {
  return CHANNELS[(channel || '').toLowerCase()] || CHANNELS.email;
}

// Strip the routing prefix so the visible reference is the actual id — the
// badge alongside it already says which channel it belongs to.
export function displayTicketId(ticketId) {
  const id = ticketId || '';
  const hit = ID_PREFIXES.find(([prefix]) => id.startsWith(prefix));
  return hit ? id.slice(hit[0].length) : id;
}
